import { Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '@/constants';
import { StockListFilters } from '@/modules/stocks/shared';
import { stockOutListColumns } from '@/modules/stocks/stock-out-list/stock-out-list.column';
import { useStockOutList } from '@/modules/stocks/stock-out-list/stock-out-list.hook';

export const StockOutList = () => {
    const { isError, error, data, isLoading, isFetching } = useStockOutList();

    return (
        <SectionContainer
            isLoading={isLoading}
            isError={isError}
            error={error}
            fallbackPath={Route.DASHBOARD}
        >
            <Card className={'space-y-4 p-4'}>
                <div className={'flex justify-between'}>
                    <div className={'space-y-4'}>
                        <HeaderBreadcrumb
                            items={[
                                {
                                    label: 'Stocks',
                                    href: Route.STOCK_ALL_PRODUCTS,
                                },
                                { label: 'Stock Out' },
                            ]}
                        />

                        <SectionTitle>Stock Out Products</SectionTitle>
                    </div>
                </div>

                <StockListFilters searchPlaceholder={'stock out products'} />

                <SectionDataTable
                    columns={stockOutListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

StockOutList.displayName = 'StockOutList';
